import moment from 'moment';

export function getCoauthorConfig(goalDetails, goalType) {
  const isPersonal = (goalDetails?.type ?? goalType) === '2';

  if (!goalDetails) return { isPersonal }; // this will trigger the Team & Time Period pickers within Co-Author
  const { team_id, team_name, start_date, target_date, filterOption } = goalDetails;

  /**
   * Converts goalDetails dates to string formats matching filterOptions (time period options)
   * @param {string | number} phpDate Sometimes this is the number of seconds since Unix epoch, other times it's a formatted string.
   * @returns MM/DD/YYYY formatted string
   */
  function toDateString(phpDate) {
    const date = moment(typeof phpDate === 'number' ? phpDate * 1000 : phpDate);
    return date.format('MM/DD/YYYY');
  }
  const startDateStr = toDateString(start_date);
  const endDateStr = toDateString(target_date);
  const timePeriod = filterOption.find(o => {
    return o.start === startDateStr && o.end === endDateStr;
  })?.name || ""; // use "" as time period name when a custom time period was used. This helps prevent the AI from saying "... in Custom Time Period" in the response

  return {
    isPersonal,
    ...team_id && !isPersonal && {team: {
      id: team_id,
      name: team_name,
    }},
    ...timePeriod && {timePeriod: {
      name: timePeriod,
      start: startDateStr,
      end: endDateStr,
    }},
  };
}